import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reduxStore from './redux';

moment.locale('zh-cn');
message.config({ duration: 3, maxCount: 5 });

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Provider store={reduxStore}>
      <App />
    </Provider>
  </ConfigProvider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
